var exports = {
  "Pf": "xe564cbfb--09762e--label",
  "Kk": "xe564cbfb--09762e--icon",
  "kL": "xe564cbfb--09762e--container",
};

module.exports = exports;
